<template>
    <div class="booking-customer">
        <h2>Your Information</h2>
        <p>Please enter your personal information below. Please note that the booking code and confirmation will be emailed to the address specified below.</p>
        <div class="form-group">
            <label for="first_name">First Name</label>
            <input v-model="customer.first_name" type="text" class="form-control" id="first_name" placeholder="First Name" />
            <div v-if="errors?.first_name?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.first_name" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="last_name">Last Name</label>
            <input v-model="customer.last_name" type="text" class="form-control" id="last_name" placeholder="Last Name" />
            <div v-if="errors?.last_name?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.last_name" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="email">Email Address</label>
            <input v-model="customer.email" type="email" class="form-control" id="email" placeholder="Email Address" />
            <div v-if="errors?.email?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.email" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="email_confirm">Confirm Email Address</label>
            <input v-model="customer.email_confirm" type="email" class="form-control" id="email_confirm" placeholder="Email Address" />
            <div v-if="errors?.email_confirm?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.email_confirm" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="telephone">Telephone</label>
            <input v-model="customer.telephone" type="tel" class="form-control" id="telephone" placeholder="Telephone" />
            <div v-if="errors?.telephone?.length > 0" class="booking-error">
                <p>There are some problems with this field.</p>
                <ul>
                    <li v-for="error, index in errors.telephone" :key="index">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: Object,
        errors: Object
    },
    computed: {
        customer: {
            get() { 
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>

<style lang="scss">
.booking-customer {
    margin-bottom: 40px;
}
</style>